import type { SimpleChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  output,
  inject,
  input,
} from '@angular/core';

import {
  HeadingComponent,
  DropdownItemComponent,
  IconButtonComponent,
  DropdownHeaderComponent,
  DropdownComponent,
} from '@core/user-interface-legacy';

import type { InsertPlaceholderInputDirective } from '../insert-placeholder-input.directive';
import { InsertPlaceholderDirective } from '../insert-placeholder.directive';
import type { Placeholder } from '../placeholder';
import { PlaceholderService } from '../placeholder.service';

@Component({
  selector: 'rt-placeholder-select-dropdown',
  templateUrl: './placeholder-select-dropdown.component.html',
  styleUrls: ['./placeholder-select-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    IconButtonComponent,
    DropdownItemComponent,
    InsertPlaceholderDirective,
    HeadingComponent,
  ],
})
export class PlaceholderSelectDropdownComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly placeholderService = inject(PlaceholderService);

  public readonly placeholders = input<Placeholder[]>(undefined!);
  public readonly activeTarget = input<InsertPlaceholderInputDirective>();
  public readonly category = input<string>(undefined!);
  public readonly showHeader = input<boolean>(undefined!);
  public readonly active = input<Placeholder>(undefined!);

  public select = output<Placeholder>();
  public back = output<void>();

  public placeholdersByCategory: Placeholder[];
  public placeholderCategoryTranslationMap =
    this.placeholderService.placeholderCategoryTranslationMap;

  public goBack(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.back.emit();
  }

  public trackByName(index: number, placeholder: Placeholder): string {
    return placeholder.id;
  }

  public withoutBrackets(str: string): string {
    return str.slice(1, -1);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.placeholders) {
      this.placeholdersByCategory = this.placeholders().filter(placeholder =>
        placeholder.id.includes(`${this.category()}.`),
      );
    }
  }
}
